import React from "react";
import { Link } from "react-router-dom";

// Post-payment thank-you page for a completed gift order. The copy is
// deliberately generic so the same page works for any gift order (one or
// many recipients, one or many courses, sent now or scheduled) — no
// order-specific data is fetched or shown. The shared site header/footer
// come from the app chrome (DynamicLayoutRoute), not this component.
const GiftSuccess: React.FC = () => (
  <div className="gift-success-page" id="gift_success">
    <div className="bg-blob one" aria-hidden="true">
      <svg viewBox="-110 -110 220 220" xmlns="http://www.w3.org/2000/svg">
        <path
          fill="#2e2437"
          d="M92.43,17.14c11.53-46.12-30-39.2-53-53s-17.5-33.22-57.65-36.89S-85.22,-52.09,-92,-17.45s.25,82.91,53,94.55S80.9,63.26,92.43,17.14Z"
        />
      </svg>
    </div>
    <div className="bg-blob two" aria-hidden="true">
      <svg viewBox="-110 -110 220 220" xmlns="http://www.w3.org/2000/svg">
        <path
          fill="#2e2437"
          d="M92.43,17.14c11.53-46.12-30-39.2-53-53s-17.5-33.22-57.65-36.89S-85.22,-52.09,-92,-17.45s.25,82.91,53,94.55S80.9,63.26,92.43,17.14Z"
        />
      </svg>
    </div>

    <section className="gift-card" aria-labelledby="gift-title">
      <div className="gift-head">
        <div className="result-icon" aria-hidden="true">
          {/* Gift box glyph, thick-stroke outline per brand icon style */}
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="3" y="9" width="18" height="4" />
            <path d="M5 13v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7" />
            <line x1="12" y1="9" x2="12" y2="21" />
            <path d="M12 9s-4.5-.2-5.6-2.1C5.7 5.7 6.6 4 8.2 4c2.4 0 3.8 5 3.8 5z" />
            <path d="M12 9s4.5-.2 5.6-2.1C18.3 5.7 17.4 4 15.8 4c-2.4 0-3.8 5-3.8 5z" />
          </svg>
        </div>
        <h1 className="gift-title" id="gift-title">
          Your gift is on its way.
        </h1>
        <ul className="gift-lines">
          <li>
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M20 6L9 17l-5-5" />
            </svg>
            <span>Your voucher is winging its way right now.</span>
          </li>
          <li>
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M20 6L9 17l-5-5" />
            </svg>
            <span>Your receipt is heading for your inbox.</span>
          </li>
        </ul>
      </div>

      <div className="next-steps">
        <h2 id="next-steps-title">What happens next</h2>
        <ol aria-labelledby="next-steps-title">
          <li>The voucher email lands on the day you chose, with your note attached.</li>
          <li>They redeem the code and start learning.</li>
          <li>They become slightly more interesting at dinner parties.</li>
        </ol>
      </div>

      <div className="gift-actions">
        <Link to="/gift" className="btn btn-blue">
          Send another gift
        </Link>
        <Link to="/courses" className="btn btn-outline">
          Explore the courses
        </Link>
      </div>

      <p className="gift-trust">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M20 6L9 17l-5-5" />
        </svg>
        <span>
          <strong>The 30-day money-back guarantee applies to gifts too.</strong>{" "}
          If they aren't happy, we aren't happy. Wrong email or wrong date?{" "}
          <a href="mailto:groundcontrol@42courses.com">
            groundcontrol@42courses.com
          </a>{" "}
          and we will sort it.
        </span>
      </p>
    </section>
  </div>
);

export default GiftSuccess;
